"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _lodash = require("lodash");
var _dates = _interopRequireDefault(require("../../../utils/dates"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var getValueOptions = function getValueOptions(question, value) {
  var result = (0, _lodash.map)(value, function (val) {
    var option = (0, _lodash.find)(question.input_options, {
      id: val
    });
    return (0, _lodash.get)(option, 'option_label', null);
  });
  return (0, _lodash.join)((0, _lodash.compact)(result), ', ');
};
var getValueSingleOption = function getValueSingleOption(question, value) {
  var option = (0, _lodash.find)(question.input_options, {
    id: value
  });
  return (0, _lodash.get)(option, 'option_label', '');
};
var formatDuration = function formatDuration(value) {
  var start = _dates["default"].formatDate(parseInt(value.start, 10));
  var end = _dates["default"].formatDate(parseInt(value.end, 10));
  return "".concat(start, " to ").concat(end);
};
function getQuestionDisplay(question) {
  var value = (0, _lodash.get)(question, 'response.response_value', null);
  if (!value) {
    return '';
  }
  switch (question.input_type) {
    case 'select':
    case 'checkbox':
      return getValueOptions(question, value);
    case 'radio':
      return getValueSingleOption(question, value);
    case 'date':
      return _dates["default"].formatDate(parseInt(value, 10));
    case 'duration':
      return formatDuration(value);
    default:
      return value.toString();
  }
}
var _default = exports["default"] = getQuestionDisplay;